import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchBookletAnnotations = createAsyncThunk(
	"bookletAnnotations/fetchBookletAnnotationsDetail",
	async (
		{ examinationCode, qpCode, bookletCode, valuationTypeCode },
		{ rejectWithValue },
	) => {
		try {
			const response = await api.get(
				`/v1/BookletAnnotation/${bookletCode}/${examinationCode}/${qpCode}/${valuationTypeCode}/booklet`,
			);

			return response.data.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

export const createBookletAnnotations = createAsyncThunk(
	"bookletAnnotations/createBookletAnnotations",
	async (payload, { rejectWithValue }) => {
		try {
			const response = await api.post("/v1/BookletAnnotation", payload);

			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

export const deleteBookletAnnotations = createAsyncThunk(
	"bookletAnnotations/deleteBookletAnnotations",
	async (annotationId, { rejectWithValue }) => {
		try {
			const response = await api.delete("/v1/BookletAnnotation", {
				data: {
					annotationId,
				},
			});

			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);

const initialState = {
	data: [],
	bookletAnnotatonId: null,
	loading: false,
	error: null,
	activeFetchRequestId: null,
};
const getAnnotationIdFromResponse = (payload, fallbackId = null) => {
	const data = payload?.data;

	if (data && typeof data === "object") {
		return (
			data.annotationId ?? data.bookletAnnotationId ?? data.id ?? fallbackId
		);
	}

	return fallbackId;
};

const bookletAnnotationsSlice = createSlice({
	name: "bookletAnnotations",
	initialState,
	reducers: {
		clearBookletAnnotations: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchBookletAnnotations.pending, (state, action) => {
				state.loading = true;
				state.error = null;
				state.activeFetchRequestId = action.meta.requestId;
			})
			.addCase(fetchBookletAnnotations.fulfilled, (state, action) => {
				if (state.activeFetchRequestId !== action.meta.requestId) return;

				state.loading = false;
				state.data = action.payload;
				state.activeFetchRequestId = null;
			})
			.addCase(fetchBookletAnnotations.rejected, (state, action) => {
				if (state.activeFetchRequestId !== action.meta.requestId) return;
				state.loading = false;
				state.error = action.payload;
				state.activeFetchRequestId = null;
			})

			.addCase(createBookletAnnotations.pending, (state) => {
				state.loading = true;
			})
			.addCase(createBookletAnnotations.fulfilled, (state, action) => {
				state.loading = false;
				const payload = action.meta.arg;

				const index = state.data.findIndex(
					(item) => item.pageIndex === payload.pageIndex,
				);

				const existingAnnotationId =
					index !== -1 ? state.data[index].annotationId : null;

				const newAnnotationId = getAnnotationIdFromResponse(
					action.payload,
					existingAnnotationId,
				);

				if (index !== -1) {
					state.data[index] = {
						...state.data[index],
						annotationId: newAnnotationId,
						annotationCode: payload.annotationCode,
					};
				} else {
					state.data.push({
						...payload,
						annotationId: newAnnotationId,
					});
				}
			})
			.addCase(createBookletAnnotations.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})

			.addCase(deleteBookletAnnotations.fulfilled, (state, action) => {
				state.loading = false;

				state.data = state.data.filter(
					(item) => item.annotationId !== action.meta.arg,
				);
			})
			.addCase(deleteBookletAnnotations.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearBookletAnnotations } = bookletAnnotationsSlice.actions;
export default bookletAnnotationsSlice.reducer;
